import {Injectable} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {ApiMode, ConfigService} from '@shared-library';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {NGXLogger} from 'ngx-logger';

@Injectable()
export class IsTefcaModeAuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private configService: ConfigService,
    private logger: NGXLogger,
  ) {

  }


  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise <boolean> {
    if(!this.configService.systemConfig$.tefcaMode){
      return Promise.resolve(true) //skip tefcaMode checks
    }

    const identityVerificationHandled =
      this.configService.vaultProfileConfig$.identityVerificationHandledForSession === true;

    return this.authService.GetSession()
      .then(session => {
        //check if the user is authenticated, if not, redirect to login
        if (!session) {
          if (route.url.toString() === '/auth/signin') {
            return true
          }
          this.logger.info("User is not authenticated, redirecting to login page")
          return this.router.navigate(['/auth/signin']);
        }
        // In test mode, revisit CSP unless this navigation handled verification.
        else if(!session.has_verified_identity ||
          (this.configService.systemConfig$.apiMode === ApiMode.Test && !identityVerificationHandled)){
          if(route.url.toString() === '/auth/identity/verification'){
            return true
          }
          this.logger.info("Profile does not have a verified identity or is in test mode, redirecting to id verification step", session)
          return this.router.navigate(['/auth/identity/verification']);
        }
        // continue as normal
        return true
      })
      .catch(err => {
        this.logger.error("error checking if user is authenticated, forcing user back to /auth/signin", err)
        return this.router.navigate(['/auth/signin']);
      })

  }
}
